import { Group } from 'models/group';

import { Reset } from './generic';

export const LOAD_GROUP_LIST = 'LOAD_GROUP_LIST';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const LOAD_GROUP_REQUEST = 'LOAD_GROUP_REQUEST';
export const DELETE_GROUP = 'DELETE_GROUP';
export const CREATE_GROUP = 'CREATE_GROUP';

export interface LoadGroupRequest {
  type: typeof LOAD_GROUP_REQUEST;
}

export interface LoadGroupData {
  type: typeof LOAD_GROUP_LIST;
  groupList: Group[];
}

export interface UpdateGroupCode {
  type: typeof UPDATE_GROUP;
  group: Group;
}

export interface DeleteGroup {
  type: typeof DELETE_GROUP;
  group: Group;
}

export interface CreateGroup {
  type: typeof CREATE_GROUP;
  group: Group;
}

export type GroupActions = LoadGroupData | UpdateGroupCode | DeleteGroup | CreateGroup | LoadGroupRequest | Reset;

export const doLoadGroupRequest = () => ({ type: LOAD_GROUP_REQUEST });

export const doLoadGroupList = (groupList: Group[]): GroupActions => ({
  type: LOAD_GROUP_LIST,
  groupList,
});

export const doUpdateGroupCode = (group: Group): GroupActions => ({
  type: UPDATE_GROUP,
  group,
});

export const doDeleteGroup = (group: Group): GroupActions => ({
  type: DELETE_GROUP,
  group,
});

export const doCreateGroup = (group: Group): GroupActions => ({
  type: CREATE_GROUP,
  group,
});
